import { DocumentType } from "../Models/DocumentType";

export const isDocumentTypeWithHtmlInput =(type: DocumentType):boolean=>{
    if(type === DocumentType.PreReleaseSoftware || type === DocumentType.PrivacyNotesForRegistration){
        return true;
    }
    return false;
}